// import React from "react";
// import Dropdown from "components/dropdown";
// import { FiAlignJustify } from "react-icons/fi";
// import { Link } from "react-router-dom";
// import navbarimage from "assets/img/layout/Navbar.png";
// import { BsArrowBarUp } from "react-icons/bs";
// import { FiSearch } from "react-icons/fi";
// import { RiMoonFill, RiSunFill } from "react-icons/ri";
// import { useOrganizers } from "components/company/hooks/useOrganizers";

// import {
//   IoMdNotificationsOutline,
//   IoMdInformationCircleOutline,
// } from "react-icons/io";
// import avatar from "assets/img/avatars/avatar4.png";

// const Navbar = (props) => {
//   const { onOpenSidenav, brandText } = props;
//   const [darkmode, setDarkmode] = React.useState(false);

//   const { companies, loading } = useOrganizers();
//   const [selectedOrganizer, setSelectedOrganizer] = React.useState(
//     localStorage.getItem("company_id") || ""
//   );

//   React.useEffect(()=>{
//      const companyID= localStorage.getItem("company_id")
//      let company = companies.find(c => c._id === companyID)
//       if(company){
//         document.documentElement.style.setProperty('--color-primary', company.primaryColor);
//       }
//   })

//   React.useEffect(() => {
//     if (selectedOrganizer) {
//       localStorage.setItem("company_id", selectedOrganizer);
//       let company = companies.find(c => c._id === selectedOrganizer)
//       if(company){
//         document.documentElement.style.setProperty('--color-primary', company.primaryColor);
//       }
//       window.dispatchEvent(
//         new CustomEvent("companyChanged", {
//           detail: selectedOrganizer,
//         })
//       );
//     }
//   }, [selectedOrganizer]);

//   return (
//     <nav className="sticky top-4 z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
//       <div className="ml-[6px]">
//         <div className="h-6 w-[224px] pt-1">
//           <a
//             className="text-sm font-normal text-navy-700 hover:underline dark:text-white dark:hover:text-white"
//             href=" "
//           >
//             Pages
//             <span className="mx-1 text-sm text-navy-700 hover:text-navy-700 dark:text-white">
//               {" "}
//               /{" "}
//             </span>
//           </a>
//           <Link
//             className="text-sm font-normal capitalize text-navy-700 hover:underline dark:text-white dark:hover:text-white"
//             to="#"
//           >
//             {brandText}
//           </Link>
//         </div>
//         <p className="shrink text-[33px] capitalize text-navy-700 dark:text-white">
//           <Link
//             to="#"
//             className="font-bold capitalize hover:text-navy-700 dark:hover:text-white"
//           >
//             {brandText}
//           </Link>
//         </p>
//       </div>

//         <Dropdown
//           button={
//             <button className="flex items-center gap-2 rounded-full bg-lightPrimary px-3 py-2 text-sm font-medium text-navy-700 dark:bg-navy-900 dark:text-white">
//               {selectedOrganizer
//                 ? companies.find(c => c._id === selectedOrganizer)?.companyName
//                 : "Select Organizer"}
//             </button>
//           }
//           children={
//             <div className="flex w-56 flex-col rounded-xl bg-white p-2 shadow-xl dark:bg-navy-700">
//               {loading && (
//                 <p className="px-3 py-2 text-sm text-gray-500">Loading...</p>
//               )}

//               {!loading && companies.length === 0 && (
//                 <p className="px-3 py-2 text-sm text-gray-500">No companies</p>
//               )}

//               {companies.map((company) => (
//                 <button
//                   key={company._id}
//                   onClick={() => setSelectedOrganizer(company._id)}
//                   className={`px-3 py-2 text-left text-sm rounded-lg hover:bg-gray-100 dark:hover:bg-white/10
//                     ${
//                       selectedOrganizer === company._id
//                         ? "bg-gray-100 dark:bg-white/10 font-semibold"
//                         : ""
//                     }`}
//                 >
//                   {company.companyName}
//                 </button>
//               ))}
//             </div>
//           }
//           classNames={"py-2 top-8 -left-[120px] w-max"}
//         />

//       <div className="relative mt-[3px] flex h-[61px] w-[60px] flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-[60px] md:flex-grow-0 md:gap-1 xl:w-[60px] xl:gap-2">
//         {/* <div className="flex h-full items-center rounded-full bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white xl:w-[225px]">
//           <p className="pl-3 pr-2 text-xl">
//             <FiSearch className="h-4 w-4 text-gray-400 dark:text-white" />
//           </p>
//           <input
//             type="text"
//             placeholder="Search..."
//             class="block h-full w-full rounded-full bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white sm:w-fit"
//           />
//         </div> */}
//         <span
//           className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden"
//           onClick={onOpenSidenav}
//         >
//           <FiAlignJustify className="h-5 w-5" />
//         </span>
//         {/* start Notification */}
//         {/*<Dropdown
//           button={
//             <p className="cursor-pointer">
//               <IoMdNotificationsOutline className="h-4 w-4 text-gray-600 dark:text-white" />
//             </p>
//           }
//           animation="origin-[65%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
//           children={
//             <div className="flex w-[360px] flex-col gap-3 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none sm:w-[460px]">
//               <div className="flex items-center justify-between">
//                 <p className="text-base font-bold text-navy-700 dark:text-white">
//                   Notification
//                 </p>
//                 <p className="text-sm font-bold text-navy-700 dark:text-white">
//                   Mark all read
//                 </p>
//               </div>

//               <button className="flex w-full items-center">
//                 <div className="flex h-full w-[85px] items-center justify-center rounded-xl bg-gradient-to-b from-brandLinear to-brand-500 py-4 text-2xl text-white">
//                   <BsArrowBarUp />
//                 </div>
//                 <div className="ml-2 flex h-full w-full flex-col justify-center rounded-lg px-1 text-sm">
//                   <p className="mb-1 text-left text-base font-bold text-gray-900 dark:text-white">
//                     New Update: Horizon UI Dashboard PRO
//                   </p>
//                   <p className="font-base text-left text-xs text-gray-900 dark:text-white">
//                     A new update for your downloaded item is available!
//                   </p>
//                 </div>
//               </button>

//               <button className="flex w-full items-center">
//                 <div className="flex h-full w-[85px] items-center justify-center rounded-xl bg-gradient-to-b from-brandLinear to-brand-500 py-4 text-2xl text-white">
//                   <BsArrowBarUp />
//                 </div>
//                 <div className="ml-2 flex h-full w-full flex-col justify-center rounded-lg px-1 text-sm">
//                   <p className="mb-1 text-left text-base font-bold text-gray-900 dark:text-white">
//                     New Update: Horizon UI Dashboard PRO
//                   </p>
//                   <p className="font-base text-left text-xs text-gray-900 dark:text-white">
//                     A new update for your downloaded item is available!
//                   </p>
//                 </div>
//               </button>
//             </div>
//           }
//           classNames={"py-2 top-4 -left-[230px] md:-left-[440px] w-max"}
//         />
//         *?}
//         {/* start Horizon PRO */}
//         {/*}
//         <Dropdown
//           button={
//             <p className="cursor-pointer">
//               <IoMdInformationCircleOutline className="h-4 w-4 text-gray-600 dark:text-white" />
//             </p>
//           }
//           children={
//             <div className="flex w-[350px] flex-col gap-2 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
//               <div
//                 style={{
//                   backgroundImage: `url(${navbarimage})`,
//                   backgroundRepeat: "no-repeat",
//                   backgroundSize: "cover",
//                 }}
//                 className="mb-2 aspect-video w-full rounded-lg"
//               />
//               <a
//                 target="blank"
//                 href="https://horizon-ui.com/pro?ref=live-free-tailwind-react"
//                 className="px-full linear flex cursor-pointer items-center justify-center rounded-xl bg-brand-500 py-[11px] font-bold text-white transition duration-200 hover:bg-brand-600 hover:text-white active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:bg-brand-200"
//               >
//                 Buy Horizon UI PRO
//               </a>
//               <a
//                 target="blank"
//                 href="https://horizon-ui.com/docs-tailwind/docs/react/installation?ref=live-free-tailwind-react"
//                 className="px-full linear flex cursor-pointer items-center justify-center rounded-xl border py-[11px] font-bold text-navy-700 transition duration-200 hover:bg-gray-200 hover:text-navy-700 dark:!border-white/10 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:active:bg-white/10"
//               >
//                 See Documentation
//               </a>
//               <a
//                 target="blank"
//                 href="https://horizon-ui.com/?ref=live-free-tailwind-react"
//                 className="hover:bg-black px-full linear flex cursor-pointer items-center justify-center rounded-xl py-[11px] font-bold text-navy-700 transition duration-200 hover:text-navy-700 dark:text-white dark:hover:text-white"
//               >
//                 Try Horizon
//               </a>
//             </div>
//           }
//           classNames={"py-2 top-6 -left-[250px] md:-left-[330px] w-max"}
//           animation="origin-[75%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
//         />
//         */}
//         <div
//           className="cursor-pointer text-gray-600"
//           onClick={() => {
//             if (darkmode) {
//               document.body.classList.remove("dark");
//               setDarkmode(false);
//             } else {
//               document.body.classList.add("dark");
//               setDarkmode(true);
//             }
//           }}
//         >
//           {darkmode ? (
//             <RiSunFill className="h-4 w-4 text-gray-600 dark:text-white" />
//           ) : (
//             <RiMoonFill className="h-4 w-4 text-gray-600 dark:text-white" />
//           )}
//         </div>
//         {/* Profile & Dropdown */}
//         </div>
//         <div className="relative mt-[3px] flex h-[61px] w-[60px] flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-[60px] md:flex-grow-0 md:gap-1 xl:w-[60px] xl:gap-2">
//           <span
//           className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden"
//           onClick={onOpenSidenav}
//         >
//           <FiAlignJustify className="h-5 w-5" />
//         </span>
//         <Dropdown
//           button={
//             <img
//               className="h-10 w-10 rounded-full"
//               src={avatar}
//               alt="Elon Musk"
//             />
//           }
//           children={
//             <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
//               <div className="p-4">
//                 <div className="flex items-center gap-2">
//                   <p className="text-sm font-bold text-navy-700 dark:text-white">
//                     👋 Hey, Adela
//                   </p>{" "}
//                 </div>
//               </div>
//               <div className="h-px w-full bg-gray-200 dark:bg-white/20 " />

//               <div className="flex flex-col p-4">
//                 <a
//                   href=" "
//                   className="text-sm text-gray-800 dark:text-white hover:dark:text-white"
//                 >
//                   Profile Settings
//                 </a>
//                 <a
//                   href=" "
//                   className="mt-3 text-sm text-gray-800 dark:text-white hover:dark:text-white"
//                 >
//                   Newsletter Settings
//                 </a>
//                 <a
//                   href=" "
//                   className="mt-3 text-sm font-medium text-red-500 hover:text-red-500 transition duration-150 ease-out hover:ease-in"
//                 >
//                   Log Out
//                 </a>
//               </div>
//             </div>
//           }
//           classNames={"py-2 top-8 -left-[180px] w-max"}
//         />

//       </div>
//     </nav>
//   );
// };

// export default Navbar;

// import React from "react";
// import Dropdown from "components/dropdown";
// import { FiAlignJustify } from "react-icons/fi";
// import { Link } from "react-router-dom";
// import { RiMoonFill, RiSunFill } from "react-icons/ri";
// import { useOrganizers } from "components/company/hooks/useOrganizers";
// import avatar from "assets/img/avatars/avatar4.png";

// const Navbar = (props) => {
//   const { onOpenSidenav, brandText, activeRouteList } = props;
//   const [darkmode, setDarkmode] = React.useState(false);

//   const { companies, loading } = useOrganizers();
//   const [selectedOrganizer, setSelectedOrganizer] = React.useState(
//     localStorage.getItem("company_id") || ""
//   );
//   const [role, setRole] = React.useState("staff");

//   React.useEffect(() => {
//     const UserData = JSON.parse(localStorage.getItem("userData"));
//     if (UserData) {
//       setRole(UserData.role || "staff");
//     }
//     const companyID = localStorage.getItem("company_id");
//     if (companyID) {
//       let company = companies.find((c) => c._id === companyID);
//       if (company) {
//         document.documentElement.style.setProperty(
//           "--color-primary",
//           company.primaryColor
//         );
//       }
//     }
//     else {
//       if (companies.length > 0) {
//         const firstCompany = companies[0];
//         localStorage.setItem("company_id", firstCompany._id);
//         setSelectedOrganizer(firstCompany._id);
//         document.documentElement.style.setProperty(
//           "--color-primary",
//           firstCompany.primaryColor
//         );
//       }}
//   }, [companies]);
//   // React.useEffect(() => {})

//   // React.useEffect(() => {})

//   React.useEffect(() => {
//     if (selectedOrganizer) {
//       localStorage.setItem("company_id", selectedOrganizer);
//       let company = companies.find((c) => c._id === selectedOrganizer);
//       if (company) {
//         document.documentElement.style.setProperty(
//           "--color-primary",
//           company.primaryColor
//         );
//       }
//       window.dispatchEvent(
//         new CustomEvent("companyChanged", {
//           detail: selectedOrganizer,
//         })
//       );
//     }
//   }, [selectedOrganizer, companies]);

//   return (
//     <nav className="navbar-div flex w-full items-center justify-between px-1 py-3">
//       {/* --- LEFT SECTION: Breadcrumbs --- */}
//       <div className="flex items-center gap-2">
//         {/* Mobile Hamburger Toggle */}
//         <button
//           onClick={onOpenSidenav}
//           className="flex rounded-lg p-1.5 text-xl text-gray-700 hover:bg-gray-200/50 dark:text-white xl:hidden"
//         >
//           <FiAlignJustify className="h-5 w-5" />
//         </button>

//         {/* Minimal Breadcrumb Path */}
//         <div className="flex items-center gap-1.5 text-xs font-medium text-gray-400">
//           <a
//             href=" "
//             className="transition-colors hover:text-gray-700 dark:hover:text-white"
//           >
//             Pages
//           </a>

//           {/* <span>/</span>
//           <span className="font-semibold capitalize text-gray-800 dark:text-white">
//             {brandText}
//           </span> */}
//           {activeRouteList.map((route, index) => {
//             const isLast = index === activeRouteList.length - 1;

//             // Build full URL path correctly using layout and path props
//             const fullPath =
//               route.layout && route.path
//                 ? `${route.layout}/${route.path}`.replace(/\/+/g, "/")
//                 : route.path || "#";

//             return (
//               <React.Fragment key={index}>
//                 <span className="text-gray-300 dark:text-gray-600">/</span>
//                 {isLast ? (
//                   /* Active/Current Page (Bold, non-clickable) */
//                   <span className="font-semibold text-gray-800 dark:text-white">
//                     {route.name}
//                   </span>
//                 ) : (
//                   /* Parent Nav Link (Clickable) */
//                   <Link
//                     to={fullPath}
//                     className="transition-colors hover:text-gray-700 dark:hover:text-white"
//                   >
//                     {route.name}
//                   </Link>
//                 )}
//               </React.Fragment>
//             );
//           })}
//         </div>
//       </div>

//       {/* --- RIGHT SECTION: Actions (Organizer Dropdown, Dark Mode, Profile) --- */}
//       <div className="flex items-center gap-3">
//         {/* Organizer Selector Dropdown */}
//         <Dropdown
//           button={
//             <button disabled={role !== "admin"} className="flex items-center gap-2 rounded-xl border border-gray-200 bg-white px-3.5 py-1.5 text-xs font-semibold text-gray-800 shadow-sm transition-all hover:bg-gray-50 dark:border-white/10 dark:bg-navy-800 dark:text-white">
//               <span className="h-2 w-2 rounded-full bg-amber-400"></span>
//               {selectedOrganizer
//                 ? companies.find((c) => c._id === selectedOrganizer)
//                     ?.companyName
//                 : "Select Organizer"}
//               <span className="ml-1 text-[10px] text-gray-400">▼</span>
//             </button>
//           }
//           children={
//             <div className="flex w-56 flex-col rounded-xl border border-gray-100 bg-white p-2 shadow-lg dark:border-white/10 dark:bg-navy-700">
//               {loading && (
//                 <p className="px-3 py-2 text-xs text-gray-500">Loading...</p>
//               )}

//               {!loading && companies.length === 0 && (
//                 <p className="px-3 py-2 text-xs text-gray-500">
//                   No companies found
//                 </p>
//               )}

//               {companies.map((company) => (
//                 <button
//                   key={company._id}
//                   onClick={() => setSelectedOrganizer(company._id)}
//                   className={`rounded-lg px-3 py-2 text-left text-xs transition-colors hover:bg-gray-100 dark:hover:bg-white/10 ${
//                     selectedOrganizer === company._id
//                       ? "bg-amber-50 font-bold text-amber-900 dark:bg-white/10 dark:text-amber-400"
//                       : "text-gray-700 dark:text-gray-200"
//                   }`}
//                 >
//                   {company.companyName}
//                 </button>
//               ))}
//             </div>
//           }
//           classNames={"py-2 top-8 right-0 w-max z-50"}
//         />

//         {/* Dark / Light Theme Toggle */}
//         <button
//           className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-gray-600 shadow-sm hover:text-gray-900 dark:bg-navy-800 dark:text-white"
//           onClick={() => {
//             if (darkmode) {
//               document.body.classList.remove("dark");
//               setDarkmode(false);
//             } else {
//               document.body.classList.add("dark");
//               setDarkmode(true);
//             }
//           }}
//         >
//           {darkmode ? (
//             <RiSunFill className="h-4 w-4 text-amber-400" />
//           ) : (
//             <RiMoonFill className="h-4 w-4 text-gray-600" />
//           )}
//         </button>

//         {/* Profile Avatar & Dropdown */}
//         <Dropdown
//           button={
//             <div className="relative cursor-pointer">
//               <img
//                 className="h-8 w-8 rounded-full border border-gray-200 object-cover"
//                 src={avatar}
//                 alt="User Profile"
//               />
//             </div>
//           }
//           children={
//             <div className="flex w-52 flex-col rounded-xl border border-gray-100 bg-white p-2 shadow-lg dark:border-white/10 dark:bg-navy-700">
//               <div className="border-b border-gray-100 p-2 dark:border-white/10">
//                 <p className="text-xs font-bold text-gray-800 dark:text-white">
//                   👋 Hey, Admin
//                 </p>
//               </div>

//               <div className="flex flex-col gap-1 p-1 pt-2 text-xs">
//                 <a
//                   href=" "
//                   className="rounded-lg px-2.5 py-1.5 text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-white/10"
//                 >
//                   Profile Settings
//                 </a>
//                 <a
//                   href=" "
//                   className="rounded-lg px-2.5 py-1.5 text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-white/10"
//                 >
//                   Account Preferences
//                 </a>
//                 <a
//                   href=" "
//                   className="rounded-lg px-2.5 py-1.5 font-medium text-red-500 hover:bg-red-50 dark:hover:bg-red-500/10"
//                 >
//                   Log Out
//                 </a>
//               </div>
//             </div>
//           }
//           classNames={"py-2 top-8 right-0 w-max z-50"}
//         />
//       </div>
//     </nav>
//   );
// };

// export default Navbar;
// import React, { useState, useEffect, useMemo } from "react";
// import Dropdown from "components/dropdown";
// import { FiAlignJustify } from "react-icons/fi";
// import { Link, useNavigate } from "react-router-dom";
// import { RiMoonFill, RiSunFill } from "react-icons/ri";
// import { useOrganizers } from "components/company/hooks/useOrganizers";
// import { useMasterCompany } from "components/masterCompanies/hooks/userMasterCompany";
// import avatar from "assets/img/avatars/avatar4.png";
// import { setAccessToken } from "api/axios";

// const Navbar = (props) => {
//   const { onOpenSidenav, activeRouteList } = props;
//   const [darkmode, setDarkmode] = useState(false);
//   const navigate = useNavigate();
//   // Hooks for Organizers & Master Companies
//   const { companies, loading: loadingCompanies } = useOrganizers();
//   const { masterCompanies, loading: loadingMaster } = useMasterCompany();

//   const [selectedMasterCompany, setSelectedMasterCompany] = useState(
//     localStorage.getItem("master_company_id") || ""
//   );
//   const [selectedOrganizer, setSelectedOrganizer] = useState(
//     localStorage.getItem("company_id") || ""
//   );
//   const [role, setRole] = useState("staff");

//   // 1. Sync User Role
//   useEffect(() => {
//     const userData = JSON.parse(localStorage.getItem("userData"));
//     if (userData) {
//       setRole(userData.role || "staff");
//     }
//   }, []);

//   // 2. Dynamically calculate filtered companies (No state lag)
//   const filteredCompanies = useMemo(() => {
//     console.log("Filtering companies for Master Company ID:", companies);
//     if (!companies || companies.length === 0) return [];
//     if (!selectedMasterCompany) return companies;
//     console.log("Filtering companies for Master Company ID:", companies);
//     return companies?.filter(
//       (c) => c.masterCompanyId === selectedMasterCompany
//     );
//   }, [companies, selectedMasterCompany]);

//   // 3. Initialize/Sync Master Company
//   useEffect(() => {
//     if (!loadingMaster && masterCompanies.length > 0) {
//       const storedCompanyId = localStorage.getItem("company_id");
//       const storedMasterId = localStorage.getItem("master_company_id");
//       // console.log("storedCompanyId",storedCompanyId);
//       // console.log("storedMasterId",storedMasterId)

//       // Case A: If an organizer ID exists, match its parent Master Company
//       if (storedCompanyId && companies.length > 0) {
//         const matchingCompany = companies.find(
//           (c) => c._id === storedCompanyId
//         );
//         if (matchingCompany && matchingCompany.masterCompanyId) {
//           setSelectedMasterCompany(matchingCompany.masterCompanyId);
//           localStorage.setItem(
//             "master_company_id",
//             matchingCompany.masterCompanyId
//           );
//           return;
//         }
//       }

//       // Case B: Fallback to stored master company or default to first
//       const exists = masterCompanies.some((mc) => mc._id === storedMasterId);
//       if (!storedMasterId || !exists) {
//         const defaultMaster = masterCompanies[0]._id;
//         setSelectedMasterCompany(defaultMaster);
//         localStorage.setItem("master_company_id", defaultMaster);
//       }
//       // console.log("afterstoredCompanyId",storedCompanyId);
//       // console.log("afterstoredMasterId",storedMasterId)
//     }
//   }, [masterCompanies, loadingMaster, companies]);

//   // 4. Initialize/Sync Selected Organizer (Company)
//   useEffect(() => {
//     if (
//       !loadingCompanies &&
//       filteredCompanies.length > 0 &&
//       selectedMasterCompany
//     ) {
//       const storedCompanyId = localStorage.getItem("company_id");
//       const existsInFiltered = filteredCompanies.some(
//         (c) => c._id === storedCompanyId
//       );

//       // If stored company doesn't belong to current master company filter, reset to 1st
//       if (!storedCompanyId || !existsInFiltered) {
//         const defaultCompany = filteredCompanies[0]._id;
//         setSelectedOrganizer(defaultCompany);
//         localStorage.setItem("company_id", defaultCompany);
//       }
//     }
//     // else if (!loadingCompanies && filteredCompanies.length === 0) {
//     //   setSelectedOrganizer("");
//     //   localStorage.removeItem("company_id");
//     // }
//   }, [filteredCompanies, loadingCompanies, selectedMasterCompany]);

//   // 5. Handle Manual Master Company Change
//   const handleMasterChange = (masterId) => {
//     setSelectedMasterCompany(masterId);
//     localStorage.setItem("master_company_id", masterId);

//     window.dispatchEvent(
//       new CustomEvent("masterCompanyChanged", { detail: masterId })
//     );
//   };

//   // 6. Handle Manual Organizer Change & Theme Styling Event Dispatch
//   useEffect(() => {
//     // const storedCompanyId = localStorage.getItem("company_id");
//     if (selectedOrganizer) {
//       localStorage.setItem("company_id", selectedOrganizer);

//       const company = companies.find((c) => c._id === selectedOrganizer);
//       if (company && company.primaryColor) {
//         document.documentElement.style.setProperty(
//           "--color-primary",
//           company.primaryColor
//         );
//       }
//       console.log("selectedOrganizer", selectedOrganizer);
//       window.dispatchEvent(
//         new CustomEvent("companyChanged", {
//           detail: selectedOrganizer,
//         })
//       );
//     }
//   }, [selectedOrganizer, companies]);

//   // Access Controls based on Role
//   const isAdmin = role === "admin";
//   const isMasterCompanyAccess = role === "admin";
//   const isOrganizerAccess = role === "admin" || role === "masterCompany";
//   // --- LOG OUT HANDLER ---
//   const handleLogout = (e) => {
//     e.preventDefault();

//     // 1. Clear access token from axios memory helper if used
//     if (typeof setAccessToken === "function") {
//       setAccessToken(null);
//     }

//     // 2. Clear all cached keys in local storage
//     localStorage.clear();

//     // 3. Redirect to login page
//     navigate("/auth/sign-in", { replace: true });
//   };
//   return (
//     <nav className="navbar-div flex w-full items-center justify-between px-1 py-1">
//       {/* --- LEFT SECTION: Breadcrumbs --- */}
//       <div className="flex items-center gap-2">
//         <button
//           onClick={onOpenSidenav}
//           className="flex rounded-lg p-1.5 text-xl text-gray-700 hover:bg-gray-200/50 dark:text-white xl:hidden"
//         >
//           <FiAlignJustify className="h-5 w-5" />
//         </button>

//         <div className="flex items-center gap-1.5 text-xs font-medium text-gray-400">
//           <a
//             href=" "
//             className="transition-colors hover:text-gray-700 dark:hover:text-white"
//           >
//             Pages
//           </a>

//           {activeRouteList.map((route, index) => {
//             const isLast = index === activeRouteList.length - 1;
//             const fullPath =
//               route.layout && route.path
//                 ? `${route.layout}/${route.path}`.replace(/\/+/g, "/")
//                 : route.path || "#";

//             return (
//               <React.Fragment key={index}>
//                 <span className="text-gray-300 dark:text-gray-600">/</span>
//                 {isLast ? (
//                   <span className="font-semibold text-gray-800 dark:text-white">
//                     {route.name}
//                   </span>
//                 ) : (
//                   <Link
//                     to={fullPath}
//                     className="transition-colors hover:text-gray-700 dark:hover:text-white"
//                   >
//                     {route.name}
//                   </Link>
//                 )}
//               </React.Fragment>
//             );
//           })}
//         </div>
//       </div>

//       {/* --- RIGHT SECTION: Dropdowns, Darkmode & Profile --- */}
//       <div className="flex items-center gap-3">
//         {/* 1. MASTER COMPANY DROPDOWN */}
//         {isAdmin && (
//           <Dropdown
//             button={
//               <button
//                 disabled={!isMasterCompanyAccess}
//                 className={`flex items-center gap-2 rounded-xl border border-gray-200 bg-white px-3.5 py-1.5 text-xs font-semibold text-gray-800 shadow-sm transition-all dark:border-white/10 dark:bg-navy-800 dark:text-white ${
//                   isMasterCompanyAccess
//                     ? "hover:bg-gray-50"
//                     : "cursor-not-allowed opacity-75"
//                 }`}
//               >
//                 <span className="h-2 w-2 rounded-full bg-indigo-500"></span>
//                 {selectedMasterCompany
//                   ? masterCompanies.find((m) => m._id === selectedMasterCompany)
//                       ?.masterCompanyName || "Select Master Company"
//                   : "Select Master Company"}
//                 {isMasterCompanyAccess && (
//                   <span className="ml-1 text-[10px] text-gray-400">▼</span>
//                 )}
//               </button>
//             }
//             children={
//               isMasterCompanyAccess && (
//                 <div className="flex w-56 flex-col rounded-xl border border-gray-100 bg-white p-2 shadow-lg dark:border-white/10 dark:bg-navy-700">
//                   {loadingMaster && (
//                     <p className="px-3 py-2 text-xs text-gray-500">
//                       Loading...
//                     </p>
//                   )}

//                   {!loadingMaster && masterCompanies.length === 0 && (
//                     <p className="px-3 py-2 text-xs text-gray-500">
//                       No Master Companies found
//                     </p>
//                   )}

//                   {masterCompanies.map((mc) => (
//                     <button
//                       key={mc._id}
//                       onClick={() => handleMasterChange(mc._id)}
//                       className={`rounded-lg px-3 py-2 text-left text-xs transition-colors hover:bg-gray-100 dark:hover:bg-white/10 ${
//                         selectedMasterCompany === mc._id
//                           ? "bg-indigo-50 font-bold text-indigo-900 dark:bg-white/10 dark:text-indigo-400"
//                           : "text-gray-700 dark:text-gray-200"
//                       }`}
//                     >
//                       {mc.masterCompanyName}
//                     </button>
//                   ))}
//                 </div>
//               )
//             }
//             classNames={"py-2 top-8 right-0 w-max z-50"}
//           />
//         )}

//         {/* 2. ORGANIZER DROPDOWN */}
//         <Dropdown
//           button={
//             <button
//               disabled={!isOrganizerAccess}
//               className={`flex items-center gap-2 rounded-xl border border-gray-200 bg-white px-3.5 py-1.5 text-xs font-semibold text-gray-800 shadow-sm transition-all dark:border-white/10 dark:bg-navy-800 dark:text-white ${
//                 isOrganizerAccess
//                   ? "hover:bg-gray-50"
//                   : "cursor-not-allowed opacity-75"
//               }`}
//             >
//               <span className="h-2 w-2 rounded-full bg-amber-400"></span>
//               {selectedOrganizer
//                 ? companies.find((c) => c._id === selectedOrganizer)
//                     ?.companyName || "Select Organizer"
//                 : "Select Organizer"}
//               {isOrganizerAccess && (
//                 <span className="ml-1 text-[10px] text-gray-400">▼</span>
//               )}
//             </button>
//           }
//           children={
//             isOrganizerAccess && (
//               <div className="flex w-56 flex-col rounded-xl border border-gray-100 bg-white p-2 shadow-lg dark:border-white/10 dark:bg-navy-700">
//                 {loadingCompanies && (
//                   <p className="px-3 py-2 text-xs text-gray-500">Loading...</p>
//                 )}

//                 {!loadingCompanies && filteredCompanies.length === 0 && (
//                   <p className="px-3 py-2 text-xs text-gray-500">
//                     No organizers found
//                   </p>
//                 )}

//                 {filteredCompanies.map((company) => (
//                   <button
//                     key={company._id}
//                     onClick={() => setSelectedOrganizer(company._id)}
//                     className={`rounded-lg px-3 py-2 text-left text-xs transition-colors hover:bg-gray-100 dark:hover:bg-white/10 ${
//                       selectedOrganizer === company._id
//                         ? "bg-amber-50 font-bold text-amber-900 dark:bg-white/10 dark:text-amber-400"
//                         : "text-gray-700 dark:text-gray-200"
//                     }`}
//                   >
//                     {company.companyName}
//                   </button>
//                 ))}
//               </div>
//             )
//           }
//           classNames={"py-2 top-8 right-0 w-max z-50"}
//         />

//         {/* Dark / Light Theme Toggle */}
//         {/* <button
//           className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-gray-600 shadow-sm hover:text-gray-900 dark:bg-navy-800 dark:text-white"
//           onClick={() => {
//             if (darkmode) {
//               document.body.classList.remove("dark");
//               setDarkmode(false);
//             } else {
//               document.body.classList.add("dark");
//               setDarkmode(true);
//             }
//           }}
//         >
//           {darkmode ? (
//             <RiSunFill className="h-4 w-4 text-amber-400" />
//           ) : (
//             <RiMoonFill className="h-4 w-4 text-gray-600" />
//           )}
//         </button> */}

//         {/* Profile Avatar & Dropdown */}
//         {/* <Dropdown
//           button={
//             <div className="relative cursor-pointer">
//               <img
//                 className="h-8 w-8 rounded-full border border-gray-200 object-cover"
//                 src={avatar}
//                 alt="User Profile"
//               />
//             </div>
//           }
//           children={
//             <div className="flex w-52 flex-col rounded-xl border border-gray-100 bg-white p-2 shadow-lg dark:border-white/10 dark:bg-navy-700">
//               <div className="border-b border-gray-100 p-2 dark:border-white/10">
//                 <p className="text-xs font-bold text-gray-800 dark:text-white">
//                   👋 Hey, {isAdmin ? "Admin" : role}
//                 </p>
//               </div>

//               <div className="flex flex-col gap-1 p-1 pt-2 text-xs">
//                 <a
//                   href=" "
//                   className="rounded-lg px-2.5 py-1.5 text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-white/10"
//                 >
//                   Profile Settings
//                 </a>
//                 <button
//                   onClick={handleLogout}
//                   className="rounded-lg px-2.5 py-1.5 font-medium text-red-500 hover:bg-red-50 dark:hover:bg-red-500/10"
//                 >
//                   Log Out
//                 </button>
//               </div>
//             </div>
//           }
//           classNames={"py-2 top-8 right-0 w-max z-50"}
//         /> */}
//       </div>
//     </nav>
//   );
// };

// export default Navbar;
import React, { useState, useEffect, useMemo } from "react";
import Dropdown from "components/dropdown";
import { FiAlignJustify } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import { useOrganizers } from "components/company/hooks/useOrganizers";
import { useMasterCompany } from "components/masterCompanies/hooks/userMasterCompany";
import avatar from "assets/img/avatars/avatar4.png";
import { setAccessToken } from "api/axios";

const updatePrimaryThemeColors = (hexColor) => {
  if (!hexColor) return;

  const root = document.documentElement;
  const hex = hexColor.replace("#", "");

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  const mixWithWhite = (amount) => {
    const newR = Math.round(r + (255 - r) * amount);
    const newG = Math.round(g + (255 - g) * amount);
    const newB = Math.round(b + (255 - b) * amount);

    return `#${newR.toString(16).padStart(2, "0")}${newG
      .toString(16)
      .padStart(2, "0")}${newB.toString(16).padStart(2, "0")}`.toUpperCase();
  };

  root.style.setProperty("--color-primary", hexColor);
  root.style.setProperty("--color-primary-35", mixWithWhite(0.35));
  root.style.setProperty("--color-primary-10", mixWithWhite(0.90));
};

const Navbar = (props) => {
  const { onOpenSidenav, activeRouteList } = props;
  const [darkmode, setDarkmode] = useState(false);
  const navigate = useNavigate();
  
  // Hooks for Organizers & Master Companies
  const { companies = [], loading: loadingCompanies } = useOrganizers();
  const { masterCompanies = [], loading: loadingMaster } = useMasterCompany();

  const [selectedMasterCompany, setSelectedMasterCompany] = useState(
    localStorage.getItem("master_company_id") || ""
  );
  const [selectedOrganizer, setSelectedOrganizer] = useState(
    localStorage.getItem("company_id") || ""
  );
  const [role, setRole] = useState("staff");

  // 1. Sync User Role
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    if (userData) {
      setRole(userData.role || "staff");
    }
  }, []);

  // 2. Dynamically calculate filtered companies
  const filteredCompanies = useMemo(() => {
    if (!companies || companies.length === 0) return [];
    if (!selectedMasterCompany) return companies;
    return companies.filter(
      (c) => c.masterCompanyId === selectedMasterCompany
    );
  }, [companies, selectedMasterCompany]);

  // 3. Initialize/Sync Master Company (FIXED: Waits for both APIs to finish loading)
  useEffect(() => {
    if (loadingMaster || loadingCompanies || masterCompanies.length === 0) return;

    const storedCompanyId = localStorage.getItem("company_id");
    const storedMasterId = localStorage.getItem("master_company_id");

    // Case A: If an organizer ID exists in localStorage, match its parent Master Company
    if (storedCompanyId && companies.length > 0) {
      const matchingCompany = companies.find(
        (c) => c._id === storedCompanyId
      );
      if (matchingCompany && matchingCompany.masterCompanyId) {
        setSelectedMasterCompany(matchingCompany.masterCompanyId);
        localStorage.setItem(
          "master_company_id",
          matchingCompany.masterCompanyId
        );
        return;
      }
    }

    // Case B: Fallback to stored master company or default to first master company
    const exists = masterCompanies.some((mc) => mc._id === storedMasterId);
    if (!storedMasterId || !exists) {
      const defaultMaster = masterCompanies[0]._id;
      setSelectedMasterCompany(defaultMaster);
      localStorage.setItem("master_company_id", defaultMaster);
    }
  }, [masterCompanies, loadingMaster, companies, loadingCompanies]);

  // 4. Initialize/Sync Selected Organizer (FIXED: Sets default company once data is ready)
  useEffect(() => {
    if (loadingCompanies || !selectedMasterCompany) return;

    if (filteredCompanies.length > 0) {
      const storedCompanyId = localStorage.getItem("company_id");
      const existsInFiltered = filteredCompanies.some(
        (c) => c._id === storedCompanyId
      );

      // If stored company is missing or doesn't belong to current master company, pick the first valid company
      if (!storedCompanyId || !existsInFiltered) {
        const defaultCompany = filteredCompanies[0]._id;
        setSelectedOrganizer(defaultCompany);
        localStorage.setItem("company_id", defaultCompany);
      } else {
        // Ensure state aligns with valid stored company
        setSelectedOrganizer(storedCompanyId);
      }
    } else {
      setSelectedOrganizer("");
    }
  }, [filteredCompanies, loadingCompanies, selectedMasterCompany]);

  // 5. Handle Manual Master Company Change
  const handleMasterChange = (masterId) => {
    setSelectedMasterCompany(masterId);
    localStorage.setItem("master_company_id", masterId);

    window.dispatchEvent(
      new CustomEvent("masterCompanyChanged", { detail: masterId })
    );
  };

  // 6. MASTER COMPANY-BASED Theme Color Update & Organizer Change Dispatch
  useEffect(() => {
    // Update theme based on selected MASTER COMPANY
    if (selectedMasterCompany && masterCompanies.length > 0) {
      const masterComp = masterCompanies.find(
        (mc) => mc._id === selectedMasterCompany
      );
      if (masterComp && (masterComp.primaryColor || masterComp.color)) {
        updatePrimaryThemeColors(masterComp.primaryColor || masterComp.color);
      }
    }

    // Dispatch custom event for company changes
    if (selectedOrganizer) {
      localStorage.setItem("company_id", selectedOrganizer);
      window.dispatchEvent(
        new CustomEvent("companyChanged", {
          detail: selectedOrganizer,
        })
      );
    }
  }, [selectedMasterCompany, masterCompanies, selectedOrganizer]);

  // Access Controls based on Role
  const isAdmin = role === "admin";
  const isMasterCompanyAccess = role === "admin";
  const isOrganizerAccess = role === "admin" || role === "masterCompany";

  // --- LOG OUT HANDLER ---
  const handleLogout = (e) => {
    e.preventDefault();

    if (typeof setAccessToken === "function") {
      setAccessToken(null);
    }

    localStorage.clear();
    navigate("/auth/sign-in", { replace: true });
  };

  return (
    <nav className="navbar-div flex w-full items-center justify-between px-1 py-1">
      {/* --- LEFT SECTION: Breadcrumbs --- */}
      <div className="flex items-center gap-2">
        <button
          onClick={onOpenSidenav}
          className="flex rounded-lg p-1.5 text-xl text-gray-700 hover:bg-gray-200/50 dark:text-white xl:hidden"
        >
          <FiAlignJustify className="h-5 w-5" />
        </button>

        <div className="flex items-center gap-1.5 text-xs font-medium text-gray-400">
          <a
            href=" "
            className="transition-colors hover:text-gray-700 dark:hover:text-white"
          >
            Pages
          </a>

          {activeRouteList.map((route, index) => {
            const isLast = index === activeRouteList.length - 1;
            const fullPath =
              route.layout && route.path
                ? `${route.layout}/${route.path}`.replace(/\/+/g, "/")
                : route.path || "#";

            return (
              <React.Fragment key={index}>
                <span className="text-gray-300 dark:text-gray-600">/</span>
                {isLast ? (
                  <span className="font-semibold text-gray-800 dark:text-white">
                    {route.name}
                  </span>
                ) : (
                  <Link
                    to={fullPath}
                    className="transition-colors hover:text-gray-700 dark:hover:text-white"
                  >
                    {route.name}
                  </Link>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>

      {/* --- RIGHT SECTION: Dropdowns, Darkmode & Profile --- */}
      <div className="flex items-center gap-3">
        {/* 1. MASTER COMPANY DROPDOWN */}
        {isAdmin && (
          <Dropdown
            button={
              <button
                disabled={!isMasterCompanyAccess}
                className={`flex items-center gap-2 rounded-xl border border-gray-200 bg-white px-3.5 py-1.5 text-xs font-semibold text-gray-800 shadow-sm transition-all dark:border-white/10 dark:bg-navy-800 dark:text-white ${
                  isMasterCompanyAccess
                    ? "hover:bg-gray-50"
                    : "cursor-not-allowed opacity-75"
                }`}
              >
                <span className="h-2 w-2 rounded-full bg-indigo-500"></span>
                {selectedMasterCompany
                  ? masterCompanies.find((m) => m._id === selectedMasterCompany)
                      ?.masterCompanyName || "Select Master Company"
                  : "Select Master Company"}
                {isMasterCompanyAccess && (
                  <span className="ml-1 text-[10px] text-gray-400">▼</span>
                )}
              </button>
            }
            children={
              isMasterCompanyAccess && (
                <div className="flex w-56 flex-col rounded-xl border border-gray-100 bg-white p-2 shadow-lg dark:border-white/10 dark:bg-navy-700">
                  {loadingMaster && (
                    <p className="px-3 py-2 text-xs text-gray-500">
                      Loading...
                    </p>
                  )}

                  {!loadingMaster && masterCompanies.length === 0 && (
                    <p className="px-3 py-2 text-xs text-gray-500">
                      No Master Companies found
                    </p>
                  )}

                  {masterCompanies.map((mc) => (
                    <button
                      key={mc._id}
                      onClick={() => handleMasterChange(mc._id)}
                      className={`rounded-lg px-3 py-2 text-left text-xs transition-colors hover:bg-gray-100 dark:hover:bg-white/10 ${
                        selectedMasterCompany === mc._id
                          ? "bg-indigo-50 font-bold text-indigo-900 dark:bg-white/10 dark:text-indigo-400"
                          : "text-gray-700 dark:text-gray-200"
                      }`}
                    >
                      {mc.masterCompanyName}
                    </button>
                  ))}
                </div>
              )
            }
            classNames={"py-2 top-8 right-0 w-max z-50"}
          />
        )}

        {/* 2. ORGANIZER DROPDOWN */}
        <Dropdown
          button={
            <button
              disabled={!isOrganizerAccess}
              className={`flex items-center gap-2 rounded-xl border border-gray-200 bg-white px-3.5 py-1.5 text-xs font-semibold text-gray-800 shadow-sm transition-all dark:border-white/10 dark:bg-navy-800 dark:text-white ${
                isOrganizerAccess
                  ? "hover:bg-gray-50"
                  : "cursor-not-allowed opacity-75"
              }`}
            >
              <span className="h-2 w-2 rounded-full bg-amber-400"></span>
              {selectedOrganizer
                ? companies.find((c) => c._id === selectedOrganizer)
                    ?.companyName || "Select Organizer"
                : "Select Organizer"}
              {isOrganizerAccess && (
                <span className="ml-1 text-[10px] text-gray-400">▼</span>
              )}
            </button>
          }
          children={
            isOrganizerAccess && (
              <div className="flex w-56 flex-col rounded-xl border border-gray-100 bg-white p-2 shadow-lg dark:border-white/10 dark:bg-navy-700">
                {loadingCompanies && (
                  <p className="px-3 py-2 text-xs text-gray-500">Loading...</p>
                )}

                {!loadingCompanies && filteredCompanies.length === 0 && (
                  <p className="px-3 py-2 text-xs text-gray-500">
                    No organizers found
                  </p>
                )}

                {filteredCompanies.map((company) => (
                  <button
                    key={company._id}
                    onClick={() => setSelectedOrganizer(company._id)}
                    className={`rounded-lg px-3 py-2 text-left text-xs transition-colors hover:bg-gray-100 dark:hover:bg-white/10 ${
                      selectedOrganizer === company._id
                        ? "bg-amber-50 font-bold text-amber-900 dark:bg-white/10 dark:text-amber-400"
                        : "text-gray-700 dark:text-gray-200"
                    }`}
                  >
                    {company.companyName}
                  </button>
                ))}
              </div>
            )
          }
          classNames={"py-2 top-8 right-0 w-max z-50"}
        />

        {/* Dark / Light Theme Toggle */}
        {/* <button
          className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-gray-600 shadow-sm hover:text-gray-900 dark:bg-navy-800 dark:text-white"
          onClick={() => {
            if (darkmode) {
              document.body.classList.remove("dark");
              setDarkmode(false);
            } else {
              document.body.classList.add("dark");
              setDarkmode(true);
            }
          }}
        >
          {darkmode ? (
            <RiSunFill className="h-4 w-4 text-amber-400" />
          ) : (
            <RiMoonFill className="h-4 w-4 text-gray-600" />
          )}
        </button> */}

        {/* Profile Avatar & Dropdown */}
        {/* <Dropdown
          button={
            <div className="relative cursor-pointer">
              <img
                className="h-8 w-8 rounded-full border border-gray-200 object-cover"
                src={avatar}
                alt="User Profile"
              />
            </div>
          }
          children={
            <div className="flex w-52 flex-col rounded-xl border border-gray-100 bg-white p-2 shadow-lg dark:border-white/10 dark:bg-navy-700">
              <div className="border-b border-gray-100 p-2 dark:border-white/10">
                <p className="text-xs font-bold text-gray-800 dark:text-white">
                  👋 Hey, {isAdmin ? "Admin" : role}
                </p>
              </div>

              <div className="flex flex-col gap-1 p-1 pt-2 text-xs">
                <a
                  href=" "
                  className="rounded-lg px-2.5 py-1.5 text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-white/10"
                >
                  Profile Settings
                </a>
                <button
                  onClick={handleLogout}
                  className="rounded-lg px-2.5 py-1.5 font-medium text-red-500 hover:bg-red-50 dark:hover:bg-red-500/10"
                >
                  Log Out
                </button>
              </div>
            </div>
          }
          classNames={"py-2 top-8 right-0 w-max z-50"}
        /> */}
      </div>
    </nav>
  );
};

export default Navbar;